export const JOB_LIST_REQUEST = "JOB_LIST_REQUEST";
export const JOB_LIST_SUCCESS = "JOB_LIST_SUCCESS";
export const JOB_LIST_FAIL = "JOB_LIST_FAIL";

export const CATEGORY_BASED_REQUEST = "CATEGORY_BASED_REQUEST";
export const CATEGORY_BASED_SUCCESS = "CATEGORY_BASED_SUCCESS";
export const CATEGORY_BASED_FAIL = "CATEGORY_BASED_FAIL";
